import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import KnowledgeBase from "../models/KnowledgeBase";

class KnowledgeBaseService extends GenericCrudServiceV2<KnowledgeBase> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  getAll(
    page: number,
    pageSize: number,
    context: { [key: string]: string | number } = {},
  ): Promise<ApiResponseV2<PagedResult<KnowledgeBase>>> {
    return HttpClientV2.get(`${this.getBasePath(context)}/all?page=${page}&pageSize=${pageSize}`);
  }

  findKnowledgeBaseCategories(): Promise<ApiResponseV2<AutoCompleteUIDTO[]>> {
    return HttpClientV2.get(`${this.basePath}/knowledge-base-categories`);
  }

  findKnowledgeBaseCodes(): Promise<ApiResponseV2<AutoCompleteUIDTO[]>> {
    return HttpClientV2.get(`${this.basePath}/knowledge-base-codes`);
  }

  findByCategory(page: number, pageSize: number, category: string): Promise<ApiResponseV2<PagedResult<KnowledgeBase>>> {
    let query = `${this.basePath}/find-by-category?page=${page}&pageSize=${pageSize}&category=${category}`;
    return HttpClientV2.get(query);
  }

  findByCode(page: number, pageSize: number, code: string): Promise<ApiResponseV2<PagedResult<KnowledgeBase>>> {
    let query = `${this.basePath}/find-by-code?page=${page}&pageSize=${pageSize}&code=${code}`;
    return HttpClientV2.get(query);
  }
}

export default new KnowledgeBaseService("/ensolvers-ops/knowledge-base");
